import type { PlatformTypeName } from "@multi-chat/shared";

/**
 * Whether Multi-Chat may start an outbound native provider Reply
 * (`reply_to.mid` on Send API).
 *
 * Distinct from inbound reply display (`Message.replyContext` / MessageReplyPreview),
 * which remains supported for Instagram Login inbound webhooks.
 *
 * Instagram API with Instagram Login does not document outbound `reply_to`
 * on graph.instagram.com; Meta rejects with validation 100/2534002.
 */
export function supportsOutboundNativeReply(platformType: PlatformTypeName): boolean {
  return platformType === "FACEBOOK" || platformType === "WHATSAPP";
}
